// removed by extract-text-webpack-plugin
module.exports = {"upload":"upload","hovered":"hovered","mouseOver":"mouseOver"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/FileDropzone/style.scss
// module id = 1213
// module chunks = 0